<div *ngIf="quadrant && quadrant.type == 'link'" class="mb-2">
  <label appFormLabel>Link</label>
  <div class="flex gap-2">
    <input class="flex-1 " appFormInput type="text" [(ngModel)]="quadrant.link">
    <button (click)="updateLink()" class="rounded-full border border-primary bg-primary hover:text-primary hover:bg-transparent p-2 w-10 h-10 text-white">
      <svg  xmlns="http://www.w3.org/2000/svg"  class="w-6" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round" ><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2" /><path d="M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" /><path d="M14 4l0 4l-6 0l0 -4" /></svg>
    </button>
  </div>
</div>
